import { matchCasbinPolicy } from '@/hooks/useAuth';

// 新系统尚未配置 MODULES 时，管理员必须能进入基础配置页面完成初始化。
const INITIAL_SYSTEM_MENU_KEYS = [
  'systemSettingsMode',
  'systemSettingsMode-systemResource',
  'systemSettingsMode-systemResource-dataCenterManagement',
  'systemSettingsMode-systemSettings',
  'systemSettingsMode-systemSettings-systemMenus',
];

/** 空菜单配置仅为具备系统管理员权限的用户提供初始化入口，不覆盖已有菜单配置。 */
export function resolveSystemMenuConfig(backMenu: string[], policies: string[][]): string[] {
  if (backMenu.length) return backMenu;
  const isSystemAdmin = policies.some((policy) => matchCasbinPolicy(policy, '*', '-', '-', '*', '*', '*', '*'));
  return isSystemAdmin ? INITIAL_SYSTEM_MENU_KEYS : backMenu;
}
